export default {"src":"/_next/static/media/experts.22cffd2f.svg","height":165,"width":262};